import styled from 'styled-components'
import { Dropdown } from '@sketch/components'

export const DropdownLink = styled(Dropdown.Item.NavLink)`
  white-space: pre;
`
